/**
 * @ComponentFor EPiServer.Core.ContentArea
 */
import * as React from 'react';
import { connect } from 'react-redux';
import { resolveSyncIfLoadedOrThrow } from '@avensia/nitro5-scope';
import { supportsComponentProp, supportsComponentPropName } from '../EpiProperty';
class ContentAreaItem extends React.Component {
    constructor() {
        super(...arguments);
        this.base = (props) => React.createElement("div", Object.assign({}, this.props.wrappingAttrs, props));
    }
    render() {
        const passThroughProps = {};
        if (this.props.className) {
            passThroughProps.className = this.props.className;
        }
        if (this.props.component[supportsComponentPropName]) {
            return React.createElement(this.props.component, Object.assign({}, passThroughProps, this.props.item, { component: this.base }));
        }
        else {
            return (React.createElement("div", Object.assign({}, passThroughProps, this.props.wrappingAttrs),
                React.createElement(this.props.component, Object.assign({}, this.props.item))));
        }
    }
}
export function contentAreaItems(propertyName, items, currentTheme) {
    return (items || [])
        .filter(i => !!i)
        .map((item, i) => {
        const Component = resolveSyncIfLoadedOrThrow(item.componentName, currentTheme);
        const itemAttrs = window.IS_IN_EDIT_MODE && propertyName
            ? {
                'data-epi-block-id': item.$idForOnPageEditing,
                'data-epi-block-info': '{"missingrenderer":false}',
            }
            : {};
        return React.createElement(ContentAreaItem, { key: i, component: Component, item: item, wrappingAttrs: itemAttrs });
    });
}
export default supportsComponentProp(connect((state) => ({
    currentTheme: state.currentTheme,
}))(({ component: Component = 'div', className = '', propertyName, items, currentTheme, }) => (React.createElement(Component, { className: className }, contentAreaItems(propertyName, items, currentTheme)))));
